import { Component, OnInit } from '@angular/core';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import {
	faAddressCard,
	faAngleRight,
	faUser,
	faBook,
	faDatabase,
	faPlus,
	faAnchor,
	faGear,
	faHeadset,
	faUsers,
	faXmark,
	faLock,
	faBell,
	faCube,
} from '@fortawesome/free-solid-svg-icons';
import { PermissionService } from 'src/app/util/services/permission/permission.service';
import { registerAccordionInterface } from 'src/app/util/interfaces/register/registerAccordion';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from 'src/app/services/global/global.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'app-register-page',
	templateUrl: './register-page.component.html',
	styleUrls: ['./register-page.component.scss'],
})
export class RegisterPageComponent implements OnInit {
	icons = {
		faDatabase: faDatabase,
		faAddressCard: faAddressCard,
		faUser: faUser,
		faUsers: faUsers,
		faAngleRight: faAngleRight,
		faBook: faBook,
		faPlus: faPlus,
		faGear: faGear,
		faHeadset: faHeadset,
		faXmark: faXmark,
		faLock: faLock,
		faBell: faBell,
		faCube: faCube,
	};

	labels: LabelsInterface = {
		lbl_geral_cadastro: 'Register',
		lbl_selecione_uma_opcao: 'Select an option beside',
		lbl_edocs_carregando: 'Loading',
		lbl_geral_inicio: 'Start',
		lbl_selecione_para_continuar: 'Select an option to continue',
		lbl_kb_criar: 'Create',
		lbl_geral_editar: 'Edit',
		lbl_geral_excluir: 'Delete',
		lbl_geral_pesquisar: 'Pesquisar',
		lbl_register_catalog: 'Register Catalog',
		lbl_geral_access_permission_settings: 'Access Permission Settings',
		lbl_geral_groups_users: 'Groups and Users',
		lbl_geral_analistas: 'Analysts',
		lbl_geral_usuarios: 'Endusers',
		lbl_custom_labels: 'Custom labels',
		lbl_geral_gerenciamento_de_sso: 'SSO Management',
		lbl_geral_ferramentas: 'Tools',
		lbl_geral_sim: '',
		lbl_geral_nao: '',
		lbl_mostrar_opcoes_escondidas: '',
		lbl_permissoes_acesso_area: '',
		lbl_geral_avaliar: 'Evaluate',
		lbl_grupo_aprovadores: '',
		lbl_geral_notificacoes: '',
		lbl_geral_gerenciamento_notificacao: '',
	};

	parentOptions: registerAccordionInterface[] = [
		{ id: 'customer', name: 'Customer', label: 'lbl_geral_clientes', icon: 'faUser', permission: '', childs: [], hidden: false },
		{
			id: 'myAsset',
			name: 'MyAsset',
			label: 'MyAsset',
			icon: 'faCube',
			permission: 'configuration_myasset',
			childs: [],
			hidden: false,
		},
		{ id: 'cmdb', name: 'CMDB', label: 'CMDB', icon: 'faDatabase', permission: '', childs: [], hidden: false },
		{ id: 'request', name: 'Request', label: 'lbl_chamado', icon: 'faHeadset', permission: '', childs: [], hidden: false },
		{ id: 'accesses', name: 'Acessos', label: 'lbl_acessos', icon: 'faLock', permission: '', childs: [], hidden: false },
		{
			id: 'knowledgeManagement',
			name: 'knowledgeManagement',
			label: 'knowledgeManagement',
			icon: 'faBook',
			permission: '',
			childs: [],
			hidden: false,
		},
		{
			id: 'notification',
			name: 'Notification',
			label: 'lbl_geral_notificacoes',
			icon: 'faBell',
			permission: '',
			childs: [],
			hidden: false,
		},
	];

	customerChildOptions: registerAccordionInterface[] = [
		{ id: 'customer', name: 'customer', label: 'lbl_geral_cliente', icon: '', permission: '', hidden: false },
		{ id: 'stylesheet', name: 'Stylesheet', label: 'lbl_geral_temas', icon: '', permission: 'register_stylesheet', hidden: false },
		{
			id: 'customLabels',
			name: 'CustomLabels',
			label: 'lbl_custom_labels',
			icon: '',
			permission: 'register_customlabels',
			hidden: false,
		},
		{
			id: 'customPresetColumnsReport',
			name: 'Predefinição de Colunas dos Relatórios',
			label: 'lbl_report_columns_default',
			icon: '',
			permission: '',
			hidden: false,
		},
		{ id: 'customEmails', name: 'CustomEmails', label: 'lbl_geral_configuracoes_de_email', icon: '', permission: '', hidden: false },
		{
			id: 'localitiesSites',
			name: 'Localidades e Sites',
			label: 'lbl_localidades_e_sites',
			icon: '',
			permission: 'register_locality|register_sites',
			hidden: false,
		},
		{
			id: 'department',
			name: 'Department',
			label: 'lbl_geral_departamentos',
			icon: '',
			permission: 'register_department',
			hidden: false,
		},
		{
			id: 'approversGroup',
			name: 'approversGroup',
			label: 'lbl_grupo_aprovadores',
			icon: '',
			permission: 'menu_cadastro',
			hidden: false,
		},
		{
			id: 'ImpactUrgencySeverity',
			name: 'ImpactUrgencySeverity',
			label: 'lbl_impacto_urgencia_severidade',
			icon: '',
			permission: '',
			hidden: false,
		},
	];

	cmdbChildOptions: registerAccordionInterface[] = [
		{
			id: 'cmdbAlert',
			name: 'CmdbAlert',
			label: 'lbl_alertas_personalizados',
			icon: '',
			permission: 'register_alertas_personalizados',
			hidden: false,
		},
		{
			id: 'cmdbCiField',
			name: 'CmdbCiField',
			label: 'lbl_criacao_campo_cmdb',
			icon: '',
			permission: 'register_custom_field_can_edit&register_ci_field_can_edit',
			hidden: false,
		},
		{
			id: 'manufacturersModels',
			name: 'Fabricantes e Modelos',
			label: 'lbl_fabricantes_e_modelos',
			icon: '',
			permission: 'register_fabricantes|register_modelo',
			hidden: false,
		},
		{ id: 'cmdbLoad', name: 'CmdbLoad', label: 'lbl_carga_ativos', icon: '', permission: 'cmdb_bulk_insert', hidden: false },
		{
			id: 'cmdbOperationalSystem',
			name: 'cmdbOperationalSystem',
			label: 'lbl_asset_sistema_operacional',
			icon: '',
			permission: 'register_modelo',
			hidden: false,
		},
		{
			id: 'cmdbCpuModel',
			name: 'cmdbCpuModel',
			label: 'lbl_asset_processadores',
			icon: '',
			permission: 'register_modelo',
			hidden: false,
		},
		{
			id: 'statusSubstatus',
			name: 'Status e Substatus',
			label: 'lbl_status_e_substatus',
			icon: '',
			permission: 'register_status|register_substatus',
			hidden: false,
		},
	];

	myAssetChildOptions: registerAccordionInterface[] = [
		{
			id: 'myAssetConfig',
			name: 'Configuração MyAsset',
			label: 'lbl_configuracao_myasset',
			icon: '',
			permission: 'configuration_myasset',
			hidden: false,
		},
	];

	accessesChildOptions: registerAccordionInterface[] = [
		{ id: 'users', name: 'Users', label: 'lbl_geral_usuarios', icon: '', permission: 'register_usuarios', hidden: false },
		{
			id: 'accessPermissionSettings',
			name: 'Access Permission Settings',
			label: 'lbl_geral_access_permission_settings',
			icon: '',
			permission: 'register_permissoes',
			hidden: false,
		},
		{ id: 'cmdbAd', name: 'CMDB_AD', label: 'CMDB_AD', icon: '', permission: '', hidden: false },
		{ id: 'groupsUsers', name: 'Groups and Users', label: 'lbl_geral_groups_users', icon: '', permission: '', hidden: false },
		{ id: 'sso', name: 'SSO', label: 'lbl_geral_gerenciamento_de_sso', icon: '', permission: 'manage_sso', hidden: false },
	];

	requestChildOptions: registerAccordionInterface[] = [
		{
			id: 'callFieldFilter',
			name: 'Call_Field_Filter',
			label: 'lbl_geral_filtro_de_campo_do_chamado',
			icon: '',
			permission: 'access_request',
			hidden: false,
		},
		{
			id: 'customerStrike',
			name: 'customerStrike',
			label: 'lbl_configuracao_de_strike',
			icon: '',
			permission: 'access_request',
			hidden: false,
		},
		{
			id: 'taskExpiration',
			name: 'taskExpiration',
			label: 'lbl_configuracao_aprovacao_tarefa',
			icon: '',
			permission: 'access_request',
			hidden: false,
		},
		{
			id: 'taskManagement',
			name: 'taskManagement',
			label: 'lbl_gerenciamento_de_tarefas',
			icon: '',
			permission: 'access_request',
			hidden: false,
		},
		{ id: 'customStatus', name: 'customStatus', label: 'lbl_personalizacao_status', icon: '', permission: '', hidden: false },
		{
			id: 'selfserviceCatalog',
			name: 'selfserviceCatalog',
			label: 'lbl_geral_catalogo_servicos',
			icon: '',
			permission: '',
			hidden: false,
		},
		{
			id: 'requestOpeningTemplate',
			name: 'requestOpeningTemplate',
			label: 'lbl_template_abertura_chamado',
			icon: '',
			permission: '',
			hidden: false,
		},
		{ id: 'impactMatrix', name: 'impactMatrix', label: 'lbl_matriz_de_impacto', icon: '', permission: '', hidden: false },
		{ id: 'customFields', name: 'customFields', label: 'lbl_geral_campos_customizados', icon: '', permission: '', hidden: false },
		{
			id: 'customFieldsOrder',
			name: 'customFieldsOrder',
			label: 'lbl_ordenar_campos_customizados',
			icon: '',
			permission: '',
			hidden: false,
		},
		{
			id: 'customSatisfactionRequest',
			name: 'CustomSatisfactionRequest',
			label: 'lbl_pesquisa_de_satisfacao_de_chamados_personalizada',
			icon: '',
			permission: 'register_custom_satisfaction_request',
			hidden: false,
		},
		{
			id: 'slaManagement',
			name: 'slaManagement',
			label: 'lbl_geral_gerenciamento_sla',
			icon: '',
			permission: 'access_request',
			hidden: false,
		},
		{
			id: 'taskCustomField',
			name: 'taskCustomField',
			label: 'lbl_geral_campos_customizados_tarefa',
			icon: '',
			permission: 'access_request',
			hidden: false,
		},
		{
			id: 'groupManagerAnalysts',
			name: 'groupManagerAnalysts',
			label: 'lbl_geral_gerenciamento_usuarios_grupo',
			icon: '',
			permission: 'group_manager_analysts',
			hidden: false,
		},
		{
			id: 'requestCategorization',
			name: 'requestCategorization',
			label: 'lbl_geral_categorizacao_chamado',
			icon: '',
			permission: 'access_request_categorization',
			hidden: false,
		},
	];

	knowledgeManagementChildOptions: registerAccordionInterface[] = [
		{ id: 'tags', name: 'tags', label: 'tags', icon: '', permission: '', hidden: false },
	];

	notificationChildOptions: registerAccordionInterface[] = [
		{
			id: 'notificationManagement',
			name: 'notificationManagement',
			label: 'lbl_geral_gerenciamento_notificacao',
			icon: '',
			permission: 'access_request',
			hidden: false,
		},
	];

	subTab = 'locality';

	constructor(
		private LabelsService: LabelsService,
		private NotificationService: NotificationService,
		private ActivatedRoute: ActivatedRoute,
		public PermissionService: PermissionService,
		public ProfileService: ProfileService
	) {}

	isLabelsLoading = true;
	isLoadingPermissions = true;

	seeHiddenOptions = false;
	isOpenModalEvaluationMSP = false;

	selectedParentOption: registerAccordionInterface = undefined;
	selectedChildOption: registerAccordionInterface = undefined;

	ghostResizeBar = {
		mouseDown: false,
		startX: null,
		mainCol: 40,
		subCol: 60,
	};

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLabelsLoading = false;
		});
		this.checkParentOptionsPermissions();
		this.checkSelectedRoute();
	}

	checkParentOptionsPermissions(): void {
		if (
			this.ProfileService.userData().usertype == 'analyst.manager.administrator' &&
			!this.accessesChildOptions.some((child) => child.id === 'adminPasswordReset')
		) {
			this.accessesChildOptions.push({
				id: 'adminPasswordReset',
				name: 'adminPasswordReset',
				label: 'lbl_reset_de_senha',
				icon: '',
				permission: '',
				hidden: false,
			});
		}

		for (let index = 0; index < this.parentOptions.length; index++) {
			const parent = this.parentOptions[index];
			const childOptions: registerAccordionInterface[] = this[`${parent.id}ChildOptions`];

			parent.childs = [];
			for (const child of childOptions) {
				if (child.permission == '' || this.PermissionService.hasPermissions(child.permission)) {
					parent.childs.push(child.id);
				} else {
					child.hidden = true;
				}
			}

			parent.hidden = parent.childs.length === 0 ? true : false;
		}
		this.isLoadingPermissions = false;
	}

	checkSelectedRoute(): void {
		let idParent = '';
		let idChild = '';

		let selectedParent: registerAccordionInterface = undefined;
		let selectedChild: registerAccordionInterface = undefined;
		this.ActivatedRoute.url.subscribe((url) => {
			if (url[1]) idParent = url[1].path;
			if (url[2]) idChild = url[2].path;

			for (let index = 0; index < this.parentOptions.length; index++) {
				const parent = this.parentOptions[index];
				if (parent.hidden == false && parent.id.toLocaleLowerCase() == idParent.toLocaleLowerCase()) {
					selectedParent = parent;
					break;
				}
			}

			if (selectedParent == undefined) {
				selectedParent = this.parentOptions.find((p) => !p.hidden);
			}

			if (selectedParent != undefined) {
				for (let index = 0; index < this[`${selectedParent.id}ChildOptions`].length; index++) {
					const child = this[`${selectedParent.id}ChildOptions`][index];
					if (child.hidden == false && child.id.toLocaleLowerCase() == idChild.toLocaleLowerCase()) {
						selectedChild = child;
						break;
					}
				}
			}

			this.setSelectedOption(selectedParent, selectedChild);
		});
	}

	showRequiredPermissions(idParent: string, idChild: string): void {
		for (const child of this[`${idParent}ChildOptions`]) {
			if (child.id == idChild) {
				this.NotificationService.setNotificationMessage(
					`${this.labels.lbl_permissoes_acesso_area}\n${child.permission.replace('&', ', ')}`
				);
			}
		}
	}

	setSelectedOption(parent: registerAccordionInterface, child: registerAccordionInterface): void {
		this.selectedParentOption = parent;

		if (this.selectedParentOption) {
			(<registerAccordionInterface[]>this[this.selectedParentOption.id + 'ChildOptions']).sort((a, b) => {
				const labelA = this.labels[a.label] == undefined ? a.name : this.labels[a.label];
				const labelB = this.labels[b.label] == undefined ? b.name : this.labels[b.label];
				if (labelA > labelB) return 1;
				if (labelA < labelB) return -1;
				return 0;
			});

			this.selectedChildOption = child;
			let urlString = '/register';
			if (parent) urlString += `/${parent.id}`;
			if (child) urlString += `/${child.id}`;

			window.history.replaceState({}, '', urlString);

			if (child && child.id === 'localitiesSites') {
				if (this.PermissionService.hasPermissions('register_locality')) {
					this.subTab = 'locality';
				} else if (this.PermissionService.hasPermissions('register_sites')) {
					this.subTab = 'sites';
				} else {
					this.subTab = 'locality';
				}
			}
			if (child && child.id === 'manufacturersModels') {
				if (this.PermissionService.hasPermissions('register_fabricantes')) {
					this.subTab = 'manufacturer';
				} else if (this.PermissionService.hasPermissions('register_modelo')) {
					this.subTab = 'model';
				} else {
					this.subTab = 'manufacturer';
				}
			}
			if (child && child.id === 'statusSubstatus') {
				if (this.PermissionService.hasPermissions('register_status')) {
					this.subTab = 'status';
				} else if (this.PermissionService.hasPermissions('register_substatus')) {
					this.subTab = 'substatus';
				} else {
					this.subTab = 'status';
				}
			}
		}
	}

	getBreadcrumbs(): any[] {
		const breadcrumbs = [{ label: this.labels.lbl_geral_cadastro || 'Cadastro', route: '/register' }];

		if (this.selectedParentOption) {
			breadcrumbs.push({
				label: this.labels[this.selectedParentOption.label] || this.selectedParentOption.name,
				route: `/register/${this.selectedParentOption.id}`,
			});

			if (this.selectedChildOption) {
				breadcrumbs.push({
					label: this.labels[this.selectedChildOption.label] || this.selectedChildOption.name,
					route: `/register/${this.selectedParentOption.id}/${this.selectedChildOption.id}`,
				});
			}
		}

		return breadcrumbs;
	}

	getChildOptionIcon(id: string): any {
		switch (id) {
			case 'customer':
			case 'users': {
				return this.icons.faUser;
			}
			case 'stylesheet':
			case 'ImpactUrgencySeverity':
			case 'statusSubstatus':
			case 'callFieldFilter':
			case 'taskManagement':
			case 'customStatus':
			case 'slaManagement': {
				return this.icons.faGear;
			}
			case 'customLabels':
			case 'selfserviceCatalog':
			case 'requestOpeningTemplate':
			case 'tags': {
				return this.icons.faBook;
			}
			case 'customPresetColumnsReport':
			case 'myAssetConfig':
			case 'localitiesSites':
			case 'locality':
			case 'sites':
			case 'manufacturersModels':
			case 'cmdbOperationalSystem':
			case 'cmdbCpuModel':
			case 'cmdbAd':
			case 'impactMatrix': {
				return this.icons.faDatabase;
			}
			case 'customEmails':
			case 'cmdbAlert':
			case 'customerStrike':
			case 'taskExpiration':
			case 'notificationManagement': {
				return this.icons.faBell;
			}
			case 'department':
			case 'approversGroup':
			case 'groupsUsers':
			case 'groupManagerAnalysts': {
				return this.icons.faUsers;
			}
			case 'cmdbCiField':
			case 'cmdbLoad':
			case 'customFields':
			case 'taskCustomField': {
				return this.icons.faPlus;
			}
			case 'accessPermissionSettings':
			case 'sso':
			case 'adminPasswordReset': {
				return this.icons.faLock;
			}
			default: {
				return this.icons.faAddressCard;
			}
		}
	}

	getChildOptionDescription(id: string): string {
		switch (id) {
			case 'customer': {
				return 'Gerenciar informações e cadastros do cliente principal.';
			}
			case 'stylesheet': {
				return 'Configurar e personalizar os temas visuais do portal.';
			}
			case 'customLabels': {
				return 'Personalizar traduções e textos do sistema.';
			}
			case 'myAssetConfig': {
				return 'Configurar as inconsistências e ativos habilitados no MyAsset.';
			}
			case 'customPresetColumnsReport': {
				return 'Predefinir colunas padrão para os relatórios.';
			}
			case 'customEmails': {
				return 'Configurar modelos e regras de envio de e-mails.';
			}
			case 'localitiesSites': {
				return 'Cadastrar e gerenciar as localidades e sites operacionais.';
			}
			case 'department': {
				return 'Organizar a estrutura de departamentos da empresa.';
			}
			case 'approversGroup': {
				return 'Configurar grupos responsáveis por aprovações.';
			}
			case 'ImpactUrgencySeverity': {
				return 'Definir regras de impacto, urgência e severidade.';
			}
			case 'cmdbAlert': {
				return 'Configurar alertas automatizados para itens de configuração.';
			}
			case 'cmdbCiField': {
				return 'Adicionar novos campos personalizados para ativos no CMDB.';
			}
			case 'manufacturersModels': {
				return 'Cadastrar e gerenciar os fabricantes e modelos de ativos.';
			}
			case 'cmdbLoad': {
				return 'Realizar carga em lote de ativos para o inventário.';
			}
			case 'cmdbOperationalSystem': {
				return 'Gerenciar sistemas operacionais homologados.';
			}
			case 'cmdbCpuModel': {
				return 'Cadastrar modelos de processadores do inventário.';
			}
			case 'statusSubstatus': {
				return 'Definir e associar os status e substatus dos itens de configuração.';
			}
			case 'callFieldFilter': {
				return 'Filtrar campos específicos na exibição dos chamados.';
			}
			case 'customerStrike': {
				return 'Configurar políticas de advertência (strikes) de clientes.';
			}
			case 'taskExpiration': {
				return 'Definir prazos e expirações para tarefas de aprovação.';
			}
			case 'taskManagement': {
				return 'Gerenciar fluxos de trabalho e tarefas de chamados.';
			}
			case 'customStatus': {
				return 'Personalizar o ciclo de vida e status de chamados.';
			}
			case 'selfserviceCatalog': {
				return 'Estruturar o catálogo de serviços para autoatendimento.';
			}
			case 'requestOpeningTemplate': {
				return 'Criar modelos rápidos para abertura de novos chamados.';
			}
			case 'impactMatrix': {
				return 'Configurar matriz de priorização baseada em impacto.';
			}
			case 'customFields': {
				return 'Adicionar campos dinâmicos ao formulário de chamados.';
			}
			case 'customFieldsOrder': {
				return 'Definir a ordem de exibição dos campos no formulário de chamados.';
			}
			case 'customSatisfactionRequest': {
				return 'Configurar pesquisas de satisfação de atendimento.';
			}
			case 'slaManagement': {
				return 'Definir acordos de nível de serviço para atendimento.';
			}
			case 'taskCustomField': {
				return 'Criar campos customizados para tarefas específicas.';
			}
			case 'groupManagerAnalysts': {
				return 'Vincular analistas e gerenciar membros de grupos.';
			}
			case 'tags': {
				return 'Organizar tags para classificação do conhecimento.';
			}
			case 'notificationManagement': {
				return 'Gerenciar regras de notificações globais.';
			}
			case 'users': {
				return 'Visualizar e cadastrar usuários finais do sistema.';
			}
			case 'accessPermissionSettings': {
				return 'Configurar perfis de acesso e permissões gerais.';
			}
			case 'cmdbAd': {
				return 'Integrar e gerenciar configurações com Active Directory.';
			}
			case 'groupsUsers': {
				return 'Associar usuários a grupos específicos de permissão.';
			}
			case 'sso': {
				return 'Configurar autenticação única (Single Sign-On).';
			}
			case 'adminPasswordReset': {
				return 'Resetar senhas de usuários administrativamente.';
			}
			default: {
				return 'Configurações de cadastros e parâmetros do sistema.';
			}
		}
	}

	modalClose(event: Event, ignorePropagation: boolean): void {
		if (event.target === document.querySelector('#modalClose')) {
			this.isOpenModalEvaluationMSP = !this.isOpenModalEvaluationMSP;
		}
		if (ignorePropagation) {
			this.isOpenModalEvaluationMSP = !this.isOpenModalEvaluationMSP;
		}
	}

	openModalEvaluationMSP() {
		this.isOpenModalEvaluationMSP = !this.isOpenModalEvaluationMSP;
	}
	// Final Função para fechar o modal ao ser clicado em áreas que não fazem parte do modal
}
